import { render, staticRenderFns } from "./SendOptionsModal.vue?vue&type=template&id=83b52810&"
import script from "./SendOptionsModal.vue?vue&type=script&lang=js&"
export * from "./SendOptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports